<template>
    <div class="main_body">
        <a-card title="日志库" id="logstorelistBox" :style="{height:'100%'}">
            <div slot="extra">
                <a-button class="backButton" @click="goBack">返回</a-button>

            </div>
            <div class="main_body">

                <div class="box_left" :style="{width:boxLeftWidth+'px'}">
                    <p style="text-align:right;padding-right:10px;height:20px;padding:0;margin:0;">
                        <a-icon type="column-width" id="drag_btn" class="box_btn_" style="" />
                    </p>
                    <a-spin :spinning="tLoading">
                        
                        <a-tree :default-expanded-keys="['0-0']" @select="onSelect" show-icon >
                            <div slot="switcherIcon"></div>
                            <a-tree-node key="0-0" :title="projectname">
                                <a-icon slot="icon" type="project" />
                                <a-tree-node v-for="item in data" :key="item" :title="item + '  >>'">
                                    <a-icon slot="icon" type="database" />
                                    <!-- <template slot="title" slot-scope="item" >
                                    <span>{{item.eventKey}}</span>

                                </template> -->
                                </a-tree-node>
                            </a-tree-node>
                        </a-tree>
                        <a-button type="primary" @click="handleNewLogstore"
                            style="margin-left:35px;margin-top:20px;width:80px;">
                            <a-icon type="plus" />
                        </a-button>
                    </a-spin>
                </div>
                <div class="box_right"  :style="{width:'calc(100% - '+boxLeftWidth+'px)'}">
                    <div style="font-weight:bolder;font-size:16px;padding-left:20px;"> 日志库：
                        <span :class="logstorename ? '' : 'cred'">{{logstorename ? logstorename : "请选择日志库！"}}</span>
                        <a-button v-if="logstorename" type="link" style="margin-left:20px;" @click="handleManageIndex">管理索引</a-button>

                        <a-button v-if="logstorename" type="link" style="margin-left:20px;" @click="handeleLogEntry">数据接入</a-button>

                        <a-button v-if="logstorename" type="link" style="margin-left:20px;" @click="handleLogList">常用查询</a-button>
                        <a v-if="logstorename" style="font-weight: 400;font-size:14px;margin-left:30px;" href="https://help.aliyun.com/document_detail/29060.html?spm=a2c4g.11186623.6.829.6fbf1373qdVc97" target="_blank" rel="noopener noreferrer">语法文档</a>

                    </div>
                    <div  style="padding:0 20px;"  v-if="logstorename">
                        <logsearch ref="mylogsearch" :projectname="projectname" :logstorename="logstorename" :logindex="dataSourceIndex"></logsearch>
                    </div>
                </div>
            </div>
        </a-card>
        <!-- 管理索引 -->
        <div>
            <a-drawer title="管理索引" placement="right" :closable="true" :visible="visible" :width="600"
                @close="hnadleManageIndexClose">
                <a-spin :spinning="tLoading">
                    <div style="padding:0 0px;">
                        <p style="font-weight:bolder;font-size:16px"> <span
                                :class="logstorename ? '' : 'cred'">{{logstorename ? logstorename : "请选择日志库"}}</span>
                        </p>
                        <a-table bordered :data-source="dataSourceIndex" :columns="columns" rowKey="uid">
                            <template slot="datatype" slot-scope="text, record">
                                <a-select v-model="record.datatype" placeholder="" class="" style="width:100px;">
                                    <a-select-option value="text">
                                        text
                                    </a-select-option>
                                    <a-select-option value="long">
                                        long
                                    </a-select-option>
                                    <a-select-option value="double">
                                        double
                                    </a-select-option>
                                    <!-- <a-select-option value="json">
                                        json
                                    </a-select-option> -->
                                </a-select>
                            </template>

                            <template slot="sensiveswitch" slot-scope="text, record">
                                <a-switch v-if="record.datatype == 'text'" default-checked v-model="record.casesensive" />
                            </template>

                            <template slot="ccnswitch" slot-scope="text, record">
                                <a-switch v-if="record.datatype == 'text'" default-checked v-model="record.ccn" />
                            </template>

                            <template slot="keynameinput" slot-scope="text, record">
                                <a-input v-model="record.keyname" placeholder="字段名" :maxLength="50"></a-input>
                            </template>

                            <template slot="tokeninput" slot-scope="text, record">
                                <a-input v-if="record.datatype == 'text'" v-model="record.token" placeholder="建议不填" :maxLength="150"></a-input>
                            </template>

                            <template slot="operation" slot-scope="text, record">
                                <div>
                                    <span>
                                        <a-button type="link" @click="handleDelete(record.uid)">删除</a-button>
                                    </span>
                                </div>
                            </template>
                            <a-popover title="分词符简介" slot="customTitle" >
                                <template slot="content">
                                    <p>根据指定分词符，将日志内容拆分成多个词。</p>
                                    <p>以空格 " " 隔开，例如： / - &</p>
                                    <h3>分词符作用：</h3>
                                    <p>例如日志内容为/url/pic/abc.gif。<br>
如果不设置任何分词符，整条日志被作为一个词/url/pic/abc.gif，<br>
您只能通过完整字符串/url/pic/abc.gif或模糊查询/url/pic/*查找该日志。<br>
如果设置分词符为正斜线（/），则原始日志被拆分为url、pic和abc.gif三个词，<br>
您通过任意一个词或词的模糊查询都可以找到该日志，<br>例如url、abc.gif、pi*、/url/pic/abc.gif。<br>
如果设置分词符为正斜线（/）和英文句点（.），<br>则原始日志被拆分为url、url、abc和gif四个词。</p>
                                </template>
                                <span class="ant-table-column-title">分词符</span>
                                <a-icon type="question-circle" style="margin-left:20px;font-size:16px;" />
                            </a-popover>
                            
                        </a-table>
                        

                        <a-button type="primary" @click="addDefaultIndexBtn()"
                            style="margin-left:5px;margin-top:10px;" v-if="logstorename != ''">
                            使用业务埋点默认索引
                        </a-button>

                        <a-button type="primary" @click="addIndexBtn()"
                            style="margin-left:5px;margin-top:10px;width:80px;" v-if="logstorename != ''">
                            <a-icon type="plus" />
                        </a-button>

                    </div>
                </a-spin>
                <div :style="{
                            position: 'absolute',
                            left: '0',
                            bottom: 0,
                            width: '100%',
                            borderTop: '1px solid #e9e9e9',
                            padding: '10px 16px',
                            background: '#fff',
                            textAlign: 'center',
                            zIndex: 1,
                            }">
                    <a-button :style="{ marginRight: '8px' }" @click="hnadleManageIndexClose">
                        取消
                    </a-button>
                     <a-popconfirm
                        v-if="iskeycreated"
                        title="索引更新后只对新数据生效,且老数据将没有可用索引，确认要更新?"
                        ok-text="确定"
                        cancel-text="取消"
                        @confirm="handleSubmit"
                    >
                        <a-button type="primary" style="margin">
                            更新
                        </a-button>
                    </a-popconfirm>
                    
                    <a-button v-else type="primary" @click="handleSubmit" style="margin">
                            创建
                    </a-button>
                </div>
            </a-drawer>
        </div>
        <!-- 数据接入 -->
        <logentry :projectname="projectname" :logstorename="logstorename" :logentryShow="logentryShow" @onLogEntryClose="handleEntryClose"></logentry>

        <logsqllist ref="logSqlListID" :project="projectname" @sqlselected="handleSqlSelected"></logsqllist>

    </div>
</template>
<script>
import logsearch from './logsearch'
import logentry from './logentry'
import logsqllist from './logsqllist'

const columns = [
    {
        title: '字段名称',
        dataIndex: 'keyname',
        key: 'keyname',
        scopedSlots:{customRender:'keynameinput'}
    },
    {
        title: '数据类型',
        dataIndex: 'datatype',
        key: 'datatype',
        scopedSlots:{customRender:'datatype'},
    },
    {
        title:"大小写敏感",
        dataIndex:"casesensive",
        key: 'casesensive',
        scopedSlots:{customRender:'sensiveswitch'},
        align:'center'
    },
    {
        slots: { title: 'customTitle' },
        dataIndex:"token",
        key: 'token',
        align:'center',
        scopedSlots:{customRender:'tokeninput'}
    },
    {
        title:"包含中文",
        dataIndex:"ccn",
        key: 'ccn',
        scopedSlots:{customRender:'ccnswitch'},
        align:'center'

    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        scopedSlots: { customRender: 'operation' },
    }
]

const businessKeys = [
    "business",
    "businesscode",
    "version",
    "total",
    "lastsessionid",
    "shopcode",
    "shopname",
    "branchcode",
    "branchname",
    "usercode",
    "openid",
    "unionid",
    "ip",
    "county",
    "province",
    "city",
    "wifi",
    "deviceid",
    "networktype",
    "screenwidth",
    "screenheight",
    "ostype",
    "osversion",
    "manufacturer",
    "model",
    "imei",
    "mac",
    "appversion",
    "appname",
    "appsource",
    "browser",
    "browserversion",
    "useragent",
    "uuid",
    "eventtime",
    "sessionid",
    "eventname",
    "eventcode",
    "action",
    "latitude",
    "pageurl",
    "pagename",
    "refererurl",
    "referername",
    "starttime",
    "endtime",
    "attributes"
];
export default {
    data() {
        return {
            projectname:"",
            tLoading:false,
            data:[],
            logstorename:'',
            iskeycreated:false,
            dataSourceIndex:[],
            columns,
            visible:false,
            boxLeftWidth:240,
            logentryShow:false,
        };
    },
    methods: {
        handleSqlSelected(qstr){
            this.$refs.mylogsearch.searchP.sql = qstr
        },
        handleEntryClose(){
            this.logentryShow = false;
        },
        handeleLogEntry(){
            this.logentryShow = !this.logentryShow
        },
        handleLogList(){
            this.$refs.logSqlListID.onModalInit(1);
        },

        handleNewLogstore(){
            this.$router.push({
                path: "logstoreadd",
                query: {projectname:this.projectname}
            });
        },
        onSelect(item_){
            if(item_[0] != "0-0" && item_.length > 0){
                this.logstorename = item_[0];
                this.getLogStoreIndex(item_[0]);
            }

        },
        goBack() {
            this.$router.back(-1);
        },
        getLogStoreIndex(){
            let that = this;
            that.tLoading = true;
            this.dataSourceIndex = [];
            that.$store.dispatch({
                type: "logservice/querylogindex",
                params:{
                    projectname:that.projectname,
                    logstorename:that.logstorename,
                    urlparams:false
                }
            }).then((res)=>{
                if(res.status == 200){
                    if(res.data.data != 'empty'){
                        let keyData = JSON.parse(res.data.data);
                        keyData = keyData.keys;
                        for (const key in keyData) {
                            if (keyData.hasOwnProperty(key)) {
                                const element = keyData[key];
                                let indexItem = {};
                                indexItem.keyname = key;
                                indexItem.casesensive = element.caseSensitive ? element.caseSensitive : '';
                                indexItem.token = element.token ? element.token.join('') : '';
                                indexItem.datatype = element.type;
                                indexItem.ccn = element.chn ? element.chn : '';
                                indexItem.uid = that.G.generateUUID();
                                this.dataSourceIndex.push(indexItem)
                            }
                        }
                        that.iskeycreated = true;
                    }
                    else{
                        that.message.info("索引未创建")
                        that.iskeycreated = false;
                    }
                }
                that.$refs.mylogsearch.resetSearch();
                that.tLoading = false;
            }).catch(() => {
                this.tLoading = false;
            });
        },

        addIndexBtn(){
            let customData = {
                uid:this.G.generateUUID(),
                datatype:"text",
                keyname:"",
                casesensive:false,
                token: "",
                ccn:false
            }
            this.dataSourceIndex.push(customData) ;
        },
        addDefaultIndexBtn(){
            let defaultData = [
            ]

            for (let index = 0; index < businessKeys.length; index++) {
                const element = businessKeys[index];
                let defaultType = "text";
                let defaultCase = false;
                let defaultToken = " ";
                let defaultCcn = false;
                if(element == "refererurl" || element == "refererurl"){
                    defaultCase = true;
                    defaultToken = "&"
                }
                
                defaultData.push({
                    uid:this.G.generateUUID(),
                    datatype:defaultType,
                    keyname:element,
                    casesensive:defaultCase,
                    token: defaultToken,
                    ccn:defaultCcn
                })
                
            }
            this.dataSourceIndex = this.dataSourceIndex.concat(defaultData)  ;
        },
        handleDelete(uid){
            let targetData = this.dataSourceIndex;
            
            let result = targetData.filter(function(n){
                return n.uid != uid;
            });
            this.dataSourceIndex = result;
        },
        handleSubmit(){
            let isActive = this.checkIndexSource(this.dataSourceIndex);
            if(isActive){
                //如果索引未创建，调用创建接口，否则调用更新接口
                let that = this;
                let requestType = that.iskeycreated ? "update" : "create";
                that.tLoading = true;
                that.$store.dispatch({
                    type: "logservice/addlogindex",
                    params:{
                        projectname:that.projectname,
                        logstorename:that.logstorename,
                        requestType:requestType,
                        dataSourceIndex: JSON.stringify(that.dataSourceIndex),
                        urlparams:false
                    }
                }).then((res)=>{
                    if(res.status == 200 && res.data.success == '1'){
                        this.message.success("更新成功");
                        that.visible = false;
                    }
                    that.tLoading = false;
                }).catch(() => {
                    this.tLoading = false;
                });
            }
            
        },
        checkIndexSource(indexKeys){
            let allreadyKeyName = [];
            let result = true;
            for (let index = 0; index < indexKeys.length; index++) {
                const element = indexKeys[index];
                if (!element.keyname) {
                    this.message.error("索引名称不能为空");
                    result = false;
                    break
                }
                else if(allreadyKeyName.indexOf(element.keyname) != -1){
                    this.message.error("索引名称不能重复");
                    result = false;
                    break
                }
                allreadyKeyName.push(element.keyname)
            }
           
            return result;
        },
        handleManageIndex(){
            this.visible = true;
        },
        hnadleManageIndexClose(){
            this.dataSourceIndex = [];
            this.visible = false;
        }
    },
    computed:{
      
    },

    components:{
        logsearch,
        logentry,
        logsqllist
    },
    mounted(){
        let that = this;
        let query = that.$route.query;
        that.projectname = query.projectname;
        that.tLoading = true;
        that.$store.dispatch({
            type: "logservice/querylogstore",
            params:{
                projectname:that.projectname,
                urlparams:false
            }
        }).then((res)=>{
            if(res.status == 200){
                that.data = res.data.data;
            }
            that.tLoading = false;
        }).catch(() => {
            this.tLoading = false;
        });

        this.topDom = this.$refs.topDom
        this.$nextTick(() => {
            const moveDom = document.getElementById('drag_btn')
            moveDom.onmousedown = function() {
                // 鼠标拖动事件
                document.onmousemove = function(e) {
                    var endX = e.clientX;
                    let resultwidth = endX - 213;
                    if(resultwidth > 700 || resultwidth <= 20){
                        return
                    }
                    that.boxLeftWidth = resultwidth
                }
                // 鼠标松开事件
                document.onmouseup = function() {
                    document.onmousemove = null
                    document.onmouseup = null
                    moveDom.releaseCapture && moveDom.releaseCapture() //当你不在需要继续获得鼠标消息就要应该调用ReleaseCapture()释放掉
                }
                moveDom.setCapture && moveDom.setCapture() //该函数在属于当前线程的指定窗口里设置鼠标捕获
                return false
            }
        })

    }
};
</script>
<style scoped>
    .box_btn_{
        font-size: 20px;
        z-index: 999;
        cursor: col-resize;
    }
    .box_left{
        width: 240px;
        height: 100%;
        float: left;
        margin-top: 0;
        margin-bottom: 10px;
        position: relative;
        overflow: hidden;
    }
    .box_right{
        width:calc(100% - 240px);
        height: 100%;
        min-height: 700px;
        float: left;
        padding: 8px 0;
        position: relative;
        border-left: 1px solid lightgray;
        
    }
    .cred{
        color: red;
    }

    .main_body{
        width: 100%;
        height: 100%;
        position: relative;
    }
</style>

<style >
    #logstorelistBox .ant-card-body{
        padding: 0;
        width: 100%;
        height:100%;
        min-width: 1366px;
    }

    #logstorelistBox .ant-tree li span.ant-tree-switcher{
        display: none;
    }
</style>
